export default __webpack_public_path__ + "static/media/baseline-battery_charging_20-24px.59d7a5ef.svg";